import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { WhatFixService } from "../components/whatfix/whatfix.service";
import { AuthService } from "./auth.service";
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { Auth0WrapperService } from './auth0-wrapper.service';

@Component({
  selector: 'gateway',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class GatewayComponent implements OnInit, OnDestroy {
  disconnect$: Subject<boolean> = new Subject<boolean>();

  private auth0: Auth0Service;

  constructor(
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private auth0WrapperService: Auth0WrapperService,
    private whatFixService: WhatFixService
  ) { 
    this.auth0 = this.auth0WrapperService.getInstance();
  }

  ngOnInit() {
    this.authService.isAuthenticated$
      .pipe(
        take(1),
        takeUntil(this.disconnect$)
      )
      .subscribe(isAuthenticated => {
        console.log('Authentication state:', isAuthenticated);
        if (isAuthenticated) {
          console.log('User is authenticated, redirect to app');
          this.router.navigateByUrl('/trailer-reservation-system');
        } else {
          console.log('User not authenticated, starting login');
          try {
            // Call Auth0 SDK directly to bypass any wrapper issues
            this.auth0.loginWithRedirect({
              appState: { returnTo: '/gateway' },
              authorizationParams: {
                redirect_uri: `${window.location.origin}/gateway`
              }
            });
          } catch (error) {
            console.error('Error calling Auth0 loginWithRedirect:', error);
          }
        }
      });
  }

  ngOnDestroy() {
    this.disconnect$.next(true);
    this.disconnect$.unsubscribe();
  }
}
